export default {"src":"/_next/static/media/checkmark-icon.bfd235c0.svg","height":23,"width":25,"blurWidth":0,"blurHeight":0};